export const clearStorage = () => {
  localStorage.clear();
  sessionStorage.removeItem('chatMessages');
};
